import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import styled from "@emotion/styled";
import { useFormAccordo } from "./ContextAccordo";
import { NumericFormat } from "react-number-format";

const ITEM_HEIGHT = 62;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    },
  },
};

const Impostazioni = () => {
  const { formState, dispatch } = useFormAccordo();
  console.log(formState);
  return (
    <>
      <Box display="flex" flexDirection="column" m={0}>
        <FormControlLabel
          control={
            <Checkbox
              checked={
                formState.impostazioni.calcolaRimorchio === 1 ? true : false
              }
              onChange={(e) =>
                dispatch({
                  type: "set_impostazioni",
                  payload: {
                    calcolaRimorchio: e.target.checked ? 1 : 0,
                  },
                })
              }
              name="calcolaRimorchio"
            />
          }
          label="Calcola anche con Rimorchio (solo autocarro >= 35t)"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={
                formState.impostazioni.conSenzaIncasso === 1 ? true : false
              }
              onChange={(e) =>
                dispatch({
                  type: "set_impostazioni",
                  payload: {
                    conSenzaIncasso: e.target.checked ? 1 : 0,
                  },
                })
              }
              name="conSenzaIncasso"
            />
          }
          label="Con incasso"
        />
      </Box>
      <Grid
        container
        spacing={3}
        mt={2}
        wrap="wrap"
        sx={{ maxWidth: { xs: "calc(100vw - 60px)" } }}
      >
        <Grid item sm={3} xs={12}>
          <FormControl size="small" fullWidth margin="none">
            <InputLabel id="frazionamento-label">Frazionamento</InputLabel>
            <Select
              labelId="frazionamento-label"
              id="frazionamento"
              label="Frazionamento"
              value={formState.impostazioni.frazionamento.value}
              onChange={(e) =>
                dispatch({
                  type: "set_impostazioni",
                  payload: {
                    frazionamento: {
                      ...formState.impostazioni.frazionamento,
                      value: e.target.value,
                    },
                  },
                })
              }
              MenuProps={MenuProps}
            >
              {formState.impostazioni.frazionamento.dataset.map((el) => (
                <MenuItem key={el.label} value={el.value}>
                  {el.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item sm={3} xs={12}>
          <NumericFormat
            size="small"
            margin="none"
            label="% Frazionamento"
            fullWidth
            customInput={TextField}
            suffix="%"
            thousandSeparator="."
            decimalSeparator=","
            decimalScale={0}
            valueIsNumericString
            value={formState.impostazioni.frazionamentoValore}
            onValueChange={(e) =>
              dispatch({
                type: "set_impostazioni",
                payload: {
                  frazionamentoValore: e.value,
                },
              })
            }
          />
        </Grid>
        <Grid item sm={3} xs={12}>
          <FormControl size="small" fullWidth margin="none">
            <InputLabel id="calcoloScadenza-label">Calcolo Scadenza</InputLabel>
            <Select
              labelId="calcoloScadenza-label"
              id="calcoloScadenza"
              label="Calcolo Scadenza"
              value={formState.impostazioni.tipoScadenza.value}
              onChange={(e) =>
                dispatch({
                  type: "set_impostazioni",
                  payload: {
                    tipoScadenza: {
                      ...formState.impostazioni.tipoScadenza,
                      value: e.target.value,
                    },
                  },
                })
              }
              MenuProps={MenuProps}
            >
              {formState.impostazioni.tipoScadenza.dataset.map((el) => (
                <MenuItem key={el.label} value={el.value}>
                  {el.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item sm={3} xs={12}>
          <TextField
            size="small"
            margin="none"
            label="Max Giorni Scadenza"
            required
            fullWidth
            value={formState.impostazioni.valoreScadenza}
            id="valoreScadenza"
            onChange={(e) =>
              dispatch({
                type: "set_impostazioni",
                payload: {
                  valoreScadenza: e.target.value,
                },
              })
            }
            /* error={state.errorNumeroPolizza} */
          />
        </Grid>
        <Grid item sm={3} xs={12}>
          <FormControl size="small" margin="none" fullWidth>
            <InputLabel id="stato-label">Utente Gestione Accordo</InputLabel>
            <Select
              labelId="utenteGesAcc-label"
              id="utenteGesAcc"
              label="Utente Gestione Accordo"
              value={formState.impostazioni.utenteGestione.value}
              MenuProps={MenuProps}
              onChange={(e) =>
                dispatch({
                  type: "set_impostazioni",
                  payload: {
                    utenteGestione: {
                      ...formState.impostazioni.utenteGestione,
                      value: e.target.value,
                    },
                  },
                })
              }
            >
              {formState.impostazioni.utenteGestione.dataset.map((el) => (
                <MenuItem key={el.label} value={el.value}>
                  {el.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item sm={3} xs={12}>
          <FormControl size="small" fullWidth margin="none">
            <InputLabel id="tabellaScontoProgressivo-label">
              Tabella Sconto Progressivo
            </InputLabel>
            <Select
              labelId="tabellaScontoProgressivo-label"
              id="tabellaScontoProgressivo"
              label="Tabella Sconto Progressivo"
              value={formState.impostazioni.scontiTariffe.value}
              onChange={(e) =>
                dispatch({
                  type: "set_impostazioni",
                  payload: {
                    scontiTariffe: {
                      ...formState.impostazioni.scontiTariffe,
                      value: e.target.value,
                    },
                  },
                })
              }
              MenuProps={MenuProps}
            >
              {formState.impostazioni.scontiTariffe.dataset.map((el) => (
                <MenuItem key={el.label} value={el.value}>
                  {el.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </>
  );
};

export default Impostazioni;
